import { KycStatus } from '../../features/auth/interfaces/kyc.interface';
import axiosBaseApi from '../common/lib/axiosBaseApi';
import { GenerateAccessToken } from './kyc.types';

export const getKycSubmission = async (userId: string) =>
  await axiosBaseApi.get<KycStatus<GenerateAccessToken>>(`/v1/kyc/${userId}`);

export const generateKycSubmission = async (userId: string) =>
  await axiosBaseApi.post<KycStatus<GenerateAccessToken>>(`/v1/kyc/${userId}`);
